
import React from "react";
import TimesPage from "@/components/pages/TimesPage";
import { TimeItem } from "@/types/time";

interface TimesPreviewProps {
  content: {
    times?: TimeItem[];
    blockTitle?: string;
    fontSize?: 'small' | 'medium' | 'large';
  };
}

const TimesPreview: React.FC<TimesPreviewProps> = ({ content }) => {
  return (
    <div className="border rounded-lg p-4 bg-white">
      <TimesPage content={content} />
    </div>
  );
};

export default TimesPreview;
